import { render } from "./InquiryDetail.vue?vue&type=template&id=dd7ca2f0"
import script from "./InquiryDetail.vue?vue&type=script&lang=js"
export * from "./InquiryDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__